import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BannerImg from '../../../../public/assets/images/BannersFiles/27.jpg';
import StaticBanner from '../../../components/elements/StaticBanner';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-use';

const Executivemanagement = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);

  // Sample data coming from the API
  const teamMembers = [
    {
      name: isActive ? 'عبدالله سلطان بن خادم' : 'Abdullah Sultan bin Khadem',
      role: isActive ? 'المدير التنفيذي' : 'Executive Director',
      imgURL: '../../../../assets/Executive_Management_Members/binkhadem.jpg',
    },
    {
      name: isActive ? 'عبدالله سيف بن هندي' : 'Abdullah Saif bin Hindi',
      role: isActive ? 'رئيس قطاع الخدمات المؤسسية' : 'Head of Corporate Services Sector',
      imgURL: '../../../../assets/Executive_Management_Members/binhindi.jpg',
    },
    {
      name: isActive ? 'خالد القصاب' : 'Khaled Al-Qassab',
      role: isActive ? 'رئيس قطاع الموارد والاستثمار' : 'Head of Resources and Investment Sector',
      imgURL: '../../../../assets/Executive_Management_Members/qassab.jpg',
    },
    {
      name: isActive ? 'علي محمد الراشدي' : 'Ali Mohammed Al-Rashidi',
      role: isActive ? 'رئيس قطاع المشاريع والمساعدات' : 'Head of Projects and Aid Sector',
      imgURL: '../../../../assets/Executive_Management_Members/alrashdi.jpg',
    },
    // {
    //   name: isActive ? 'علي محمد الراشدي' : 'Ali Mohammed Al-Rashidi',
    //   role: isActive ? 'رئيس قطاع الموارد والاستثمار' : 'Head of Resources and Investment Sector',
    //   imgURL: '../../../../public/assets/Executive_Management_Members/alrashdi.jpg',
    // },
  ];

  // Function to get the initial letter based on the name
  const getInitial = (name) => {
    return isActive ? name.charAt(0) : name.charAt(0).toUpperCase();
  };

  return (
    <>
      <StaticBanner BannerImg={BannerImg} en_US={'Executive management'} arabic={false} />
      <div className="pb-5">
        <div className="flex flex-col  lg:flex-row justify-center items-center ">
          <div className="w-1/2 2xl:w-1/3 p-4  flex justify-center items-center  ">
            <img
              src={`/assets/images/chairman.png`}
              className=" w-full h-auto max-h-[500px] object-contain"
              alt="image"
            />
          </div>
          {/* dynamic with icons using tailwind */}
          <section
            className={`lg:w-1/2 2xl:w-2/3 flex xl:flex-row flex-col py-1 px-3 lg:px-12 ${isActive ? 'text-left' : 'text-right'}`}
          >
            <div className="container justify-center">
              <div className="max-w-screen-2xl">
                <h2
                  className={`text-xl text-center sm:text-3xl font-bold px-2 py-6 text-customgreen  flex w-full justify-center  `}
                  data-aos="fade-down"
                  data-aos-easing="ease-in-sine"
                  data-aos-offset="0"
                >
                  {t('Executive Management Members')}{' '}
                </h2>
                <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-4">
                  {teamMembers.map((member, index) => (
                    <div
                      key={index}
                      className="flex  hover:scale-105 transition-transform duration-300 items-center p-4 sm:p-5 md:p-6 bg-gray-50 rounded-lg shadow-md border border-gray-200"
                    >
                      <div className={`flex-shrink-0 ${isActive ? 'ml-3 sm:ml-4' : 'mr-3 sm:mr-4'}`}>
                        <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-green-100 rounded-full flex items-center justify-center ">
                          <span className="text-lg sm:text-xl md:text-2xl font-bold text-customgreen rounded-lg">
                            <img
                              src={member?.imgURL}
                              className=" w-full h-auto max-h-[500px] object-contain rounded-lg"
                              alt="image"
                            />
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-col justify-center text-center">
                        <h3 className="text-lg sm:text-xl font-bold text-customgreen">{member.name}</h3>
                        <p className="text-gray-700 mt-1">{member.role}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Executivemanagement;
